import { createSlice } from "@reduxjs/toolkit";
import services from "../services";

interface FavoritePostsState {
    data: any[];
    loading: boolean;
    error: boolean;
}

const initialState: FavoritePostsState = {
    data: [],
    loading: false,
    error: false,
};

const favoritePostsSlice = createSlice({
    name: "favoritePosts",
    initialState,
    reducers: {
        getFavoritePosts: (state) => {
            state.loading = true;
            state.error = false;
            state.data = [];
        },
        getFavoritePostsSuccess: (state, actions) => {
            state.loading = false;
            state.error = false;
            state.data = actions.payload;
        },
        getFavoritePostsFailure: (state) => {
            state.loading = false;
            state.error = true;
            state.data = [];
        },
    },
});

export const { getFavoritePosts, getFavoritePostsSuccess, getFavoritePostsFailure } =
    favoritePostsSlice.actions;

export default favoritePostsSlice.reducer;

export const fetchFavoritePosts =
    () =>
        async (
            dispatch: (arg0: {
                payload: any;
                type:
                    | "favoritePosts/getFavoritePosts"
                    | "favoritePosts/getFavoritePostsSuccess"
                    | "favoritePosts/getFavoritePostsFailure";
            }) => void
        ) => {
            dispatch(getFavoritePosts());
            try {
                const response = await services.favoritePosts();
                dispatch(getFavoritePostsSuccess(response.data));
            } catch (err) {
                console.log("err: ", err);
                dispatch(getFavoritePostsFailure());
            }
        };
